/** @type {import('../help-index.js').HelpScreen} */
export const SUP_PWD_HELP = {
  screenId: 'sup-pwd',
  label: 'Reset contraseñas',
  navPath: 'Soporte → Reset contraseñas',
  keywords: [
    'reset', 'contraseña', 'password', 'clave', 'olvidó la clave', 'olvidó la contraseña',
    'cambiar contraseña', 'cambiar password', 'usuario',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Elegí un usuario y asignale una contraseña nueva, por ejemplo si olvidó la suya.',
  sidebarItems: [{
    id: 'reset',
    screenId: 'sup-pwd',
    label: 'Reset contraseñas',
    description: 'Lista de usuarios y cambio de contraseña.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Si alguien no puede entrar porque olvidó la contraseña, desde acá un usuario de soporte le asigna una nueva. No hace falta saber la contraseña anterior.',
        },
        {
          title: 'Paso 1 — Abrir la pantalla',
          bullets: [
            'En el menú de arriba, tocá SOPORTE.',
            'Elegí «Reset contraseñas».',
          ],
        },
        {
          title: 'Paso 2 — Elegir el usuario',
          bullets: [
            'La lista muestra usuario, nombre y si está activo o inactivo.',
            'El interruptor «Solo usuarios activos» deja ver activos o inactivos.',
            'Tocá la fila de la persona a la que hay que cambiarle la clave.',
          ],
        },
        {
          title: 'Paso 3 — Cargar la contraseña nueva',
          fields: [
            { label: 'Nueva contraseña', description: 'Mínimo 6 caracteres; no puede ser solo números. Se permiten letras, símbolos y espacios.' },
            { label: 'Repetir nueva contraseña', description: 'Tiene que coincidir con la anterior.' },
          ],
          paragraphs: [
            'Tocá «Guardar». Si algo no cumple las reglas, el sistema avisa y no cambia nada.',
          ],
        },
        {
          title: 'Después de guardar',
          bullets: [
            'La contraseña anterior deja de servir de inmediato.',
            'La persona tiene que entrar de nuevo con la clave nueva.',
            'El usuario especial del sistema no aparece en esta lista.',
          ],
        },
      ],
    },
  }],
}
